import React, { useContext, useEffect } from 'react'
import { useQuery, useQueryClient } from 'react-query'
import { SocketContext } from './contexts/socketContext'
import {
  BrowserRouter as Router,
  Switch,
  Route,
} from "react-router-dom";
import Room from './pages/room'
import WaitingRoom from './pages/waitingRoom'

const Main = () => {

  const queryClient = useQueryClient()

  const { data: rooms, status } = useQuery('rooms', async () => {
    const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/rooms`)
    return await res.json()
  })

  const { socket } = useContext(SocketContext)

  // Setup listeners for users joining/leaving rooms
  useEffect(() => {
    if (socket && rooms) {
      socket.emit('watch-rooms', rooms.map(r => r._id))
    }
    return () => {
      socket.emit('remove-watch-rooms')
    }
  }, [socket, rooms])
  
  
  // Listeners to update room data when users join/leave rooms
  useEffect(() => {
    if (socket && rooms) {
      socket.on('update-room', (newRoom) => {
        queryClient.setQueryData('rooms', (oldRooms) => 
          oldRooms.map(r => r._id === newRoom._id ? newRoom : r)
        )
      })
    }
    return () => {
      socket.off('update-room')
    }
  }, [socket, rooms, queryClient])

  return (
    status === "loading"
    ? <div>Loading</div>
    : <Router>
        <Switch>
          <Route exact path={`/waitingroom`} >
            <WaitingRoom rooms={rooms} />
          </Route>
          <Route path={`/room/:id`}
            render={({ match }) => {
              const { id } = match.params
              const room = rooms.find(r => r._id === id)
              return <Room room={room} />
            }}
          />
        </Switch>
      </Router>
  )
}
export default Main